import React, { useState } from 'react';
import moment from 'moment';
import { IoIosInformationCircle } from "react-icons/io";
import { PropTypes } from 'prop-types';
import NotificationModal from '../../Modals/NotificationModal/NotificationModal';
import './NotificationListItem.scss';
import api from './../../../api';

NotificationListItem.propTypes = {
	notification: PropTypes.object.isRequired
}

function NotificationListItem({ notification, fetchNotifications, bottomBorder, archive }) {
	const { timeToShow, markedAsRead, title, partnersUsersNotificationsID } = notification;
	const [showModal, setShowModal] = useState(false);

	const openModal = () => setShowModal(true);

	const onHideCallback = () => {
		setShowModal(false);
		fetchNotifications();
	};

	const onHide = () => {
		if (!markedAsRead) {
			api.notifications.markNotificationAsRead(partnersUsersNotificationsID)
				.then(onHideCallback)
				.catch(onHideCallback);
		} else {
			onHideCallback();
		}
	};

	const TimeElement = ({ children }) => !archive ? <>{children}</> : <h4>{children}</h4>;
	const TitleElement = ({ children }) => !archive ? <strong>{children}</strong> : <h3>{children}</h3>;

	return (
		<>
			<div className="NotificationListItem" style={{ marginBottom: '24px'}}>
				<span className="time">
					<TimeElement>{moment(timeToShow).format('DD.MM.YYYY - HH:mm')} {!markedAsRead && <IoIosInformationCircle className="green"/>}</TimeElement>
				</span>
				<span
					style={{ color:"#007bff", cursor: 'pointer' }}
					onClick={openModal}
				>
					<TitleElement>{title}</TitleElement>
				</span>
				{bottomBorder ?
					<div style={{ borderBottom: '1px solid #f0f0f0', paddingTop: '12px' }} />
				: null}
			</div>
			<NotificationModal
				notification={notification}
				show={showModal}
				onHide={onHide}
			/>
		</>
	);
}

export default NotificationListItem;